// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: HXC9Uh84NE
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: baAq87AECkw/component
import { Password } from "@plasmicpkgs/antd/skinny/registerInput";
import { inputHelpers as Password_Helpers } from "@plasmicpkgs/antd/skinny/registerInput";
import Button from "../../Button"; // plasmic-import: qD6dz0yVMKR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicApplicationKeys.module.css"; // plasmic-import: HXC9Uh84NE/css
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: RV-6J1VywZC/icon
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: QrnmMSFuM9/icon

createPlasmicElementProxy;

export const PlasmicApplicationKeys__VariantProps = new Array();

export const PlasmicApplicationKeys__ArgProps = new Array();

const $$ = {};

function PlasmicApplicationKeys__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appId.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "apiKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``,
        onMutate: p.generateOnMutateForSpec("value", Password_Helpers)
      },
      {
        path: "clientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "webHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "devClientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "devWebHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"rectangle"}
      data-plasmic-override={overrides.rectangle}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.rectangle
      )}
    >
      <div
        data-plasmic-name={"leftSide"}
        data-plasmic-override={overrides.leftSide}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.leftSide
        )}
      >
        <React.Fragment>
          <React.Fragment>{""}</React.Fragment>
          {
            <h4
              data-plasmic-name={"h4"}
              data-plasmic-override={overrides.h4}
              className={classNames(
                projectcss.all,
                projectcss.h4,
                projectcss.__wab_text,
                sty.h4
              )}
            >
              <React.Fragment>
                <React.Fragment>{"Application Keys\n"}</React.Fragment>
                {
                  <blockquote
                    data-plasmic-name={"blockquote"}
                    data-plasmic-override={overrides.blockquote}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.blockquote
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{""}</React.Fragment>
                      {
                        <span
                          data-plasmic-name={"span"}
                          data-plasmic-override={overrides.span}
                          className={classNames(
                            projectcss.all,
                            projectcss.span,
                            projectcss.__wab_text,
                            projectcss.plasmic_default__inline,
                            sty.span
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 300 }}
                            >
                              {
                                "Your App ID and API key are used to identify your application when making requests with the Astrius Unify endpoints, as described in our documentation."
                              }
                            </span>
                          </React.Fragment>
                        </span>
                      }

                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  </blockquote>
                }

                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </h4>
          }

          <React.Fragment>{""}</React.Fragment>
        </React.Fragment>
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__yiYHo
        )}
      >
        {"App ID"}
      </div>
      <TextInput
        data-plasmic-name={"appId"}
        data-plasmic-override={overrides.appId}
        aria-labelledby={``}
        className={classNames("__wab_instance", sty.appId)}
        onChange={(...eventArgs) => {
          p.generateStateOnChangeProp($state, ["appId", "value"])(
            (e => e.target?.value).apply(null, eventArgs)
          );
        }}
        startIcon={
          <SearchsvgIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        }
        type={"text"}
        value={p.generateStateValueProp($state, ["appId", "value"]) ?? ""}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__qLkxn
        )}
      >
        {"API Key"}
      </div>
      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__neOrt)}
      >
        {(() => {
          const child$Props = {
            allowClear: false,
            "aria-label": ``,
            className: classNames("__wab_instance", sty.apiKey),
            disabled: false,
            onChange: p.generateStateOnChangePropForCodeComponents(
              $state,
              "value",
              ["apiKey", "value"],
              Password_Helpers
            ),
            type: ``,
            value: p.generateStateValueProp($state, ["apiKey", "value"]),
            visibilityToggle: true
          };
          p.initializeCodeComponentStates(
            $state,
            [
              {
                name: "value",
                plasmicStateName: "apiKey.value"
              }
            ],

            [],
            Password_Helpers ?? {},
            child$Props
          );
          return (
            <Password
              data-plasmic-name={"apiKey"}
              data-plasmic-override={overrides.apiKey}
              {...child$Props}
            />
          );
        })()}
        <Layer11Icon
          data-plasmic-name={"copyKey"}
          data-plasmic-override={overrides.copyKey}
          className={classNames(projectcss.all, sty.copyKey)}
          role={"img"}
        />
      </p.Stack>
      <div className={classNames(projectcss.all, sty.freeBox__kQZg2)}>
        <div
          data-plasmic-name={"forProduction"}
          data-plasmic-override={overrides.forProduction}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.forProduction
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5___9Up0P
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontWeight: 700 }}
                  >
                    {"Production"}
                  </span>
                </React.Fragment>
              </h5>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__vrgMp
          )}
        >
          {"WebHook Client Key"}
        </div>
        <TextInput
          data-plasmic-name={"clientKey"}
          data-plasmic-override={overrides.clientKey}
          className={classNames("__wab_instance", sty.clientKey)}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["clientKey", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={"WebHook Client Key"}
          value={p.generateStateValueProp($state, ["clientKey", "value"]) ?? ""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__pykVw
          )}
        >
          {"Webhook Url"}
        </div>
        <TextInput
          data-plasmic-name={"webHookKey"}
          data-plasmic-override={overrides.webHookKey}
          className={classNames("__wab_instance", sty.webHookKey)}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["webHookKey", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={"WebHook Url"}
          value={
            p.generateStateValueProp($state, ["webHookKey", "value"]) ?? ""
          }
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__an6Y0)}>
        <div
          data-plasmic-name={"forDevelopment"}
          data-plasmic-override={overrides.forDevelopment}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.forDevelopment
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5__ssk6G
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontWeight: 700 }}
                  >
                    {"Development"}
                  </span>
                </React.Fragment>
              </h5>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__fPDyM
          )}
        >
          {"WebHook Client Key"}
        </div>
        <TextInput
          data-plasmic-name={"devClientKey"}
          data-plasmic-override={overrides.devClientKey}
          className={classNames("__wab_instance", sty.devClientKey)}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["devClientKey", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={"WebHook Client Key"}
          value={
            p.generateStateValueProp($state, ["devClientKey", "value"]) ?? ""
          }
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__c5PtN
          )}
        >
          {"Webhook Url"}
        </div>
        <TextInput
          data-plasmic-name={"devWebHookKey"}
          data-plasmic-override={overrides.devWebHookKey}
          className={classNames("__wab_instance", sty.devWebHookKey)}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["devWebHookKey", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={"WebHook Url"}
          value={
            p.generateStateValueProp($state, ["devWebHookKey", "value"]) ?? ""
          }
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__xgEuo)}>
        <Button
          data-plasmic-name={"regenerateApiKey"}
          data-plasmic-override={overrides.regenerateApiKey}
          className={classNames("__wab_instance", sty.regenerateApiKey)}
        >
          {"Generate API Key"}
        </Button>
        <Button
          data-plasmic-name={"addKeys"}
          data-plasmic-override={overrides.addKeys}
          className={classNames("__wab_instance", sty.addKeys)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__gI9T8
            )}
          >
            {"Add Webhook"}
          </div>
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  rectangle: [
    "rectangle",
    "leftSide",
    "h4",
    "blockquote",
    "span",
    "appId",
    "svg",
    "apiKey",
    "copyKey",
    "forProduction",
    "clientKey",
    "webHookKey",
    "forDevelopment",
    "devClientKey",
    "devWebHookKey",
    "regenerateApiKey",
    "addKeys"
  ],

  leftSide: ["leftSide", "h4", "blockquote", "span"],
  h4: ["h4", "blockquote", "span"],
  blockquote: ["blockquote", "span"],
  span: ["span"],
  appId: ["appId", "svg"],
  svg: ["svg"],
  apiKey: ["apiKey"],
  copyKey: ["copyKey"],
  forProduction: ["forProduction"],
  clientKey: ["clientKey"],
  webHookKey: ["webHookKey"],
  forDevelopment: ["forDevelopment"],
  devClientKey: ["devClientKey"],
  devWebHookKey: ["devWebHookKey"],
  regenerateApiKey: ["regenerateApiKey"],
  addKeys: ["addKeys"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicApplicationKeys__ArgProps,
          internalVariantPropNames: PlasmicApplicationKeys__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicApplicationKeys__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "rectangle") {
    func.displayName = "PlasmicApplicationKeys";
  } else {
    func.displayName = `PlasmicApplicationKeys.${nodeName}`;
  }
  return func;
}

export const PlasmicApplicationKeys = Object.assign(
  // Top-level PlasmicApplicationKeys renders the root element
  makeNodeComponent("rectangle"),
  {
    // Helper components rendering sub-elements
    leftSide: makeNodeComponent("leftSide"),
    h4: makeNodeComponent("h4"),
    blockquote: makeNodeComponent("blockquote"),
    span: makeNodeComponent("span"),
    appId: makeNodeComponent("appId"),
    svg: makeNodeComponent("svg"),
    apiKey: makeNodeComponent("apiKey"),
    copyKey: makeNodeComponent("copyKey"),
    forProduction: makeNodeComponent("forProduction"),
    clientKey: makeNodeComponent("clientKey"),
    webHookKey: makeNodeComponent("webHookKey"),
    forDevelopment: makeNodeComponent("forDevelopment"),
    devClientKey: makeNodeComponent("devClientKey"),
    devWebHookKey: makeNodeComponent("devWebHookKey"),
    regenerateApiKey: makeNodeComponent("regenerateApiKey"),
    addKeys: makeNodeComponent("addKeys"),
    // Metadata about props expected for PlasmicApplicationKeys
    internalVariantProps: PlasmicApplicationKeys__VariantProps,
    internalArgProps: PlasmicApplicationKeys__ArgProps
  }
);

export default PlasmicApplicationKeys;
/* prettier-ignore-end */
